import React from 'react'
import styled, { keyframes } from 'styled-components'


export const colors = {
    dark: {
        bg: "#161A1D",
        border: "#FF9505",
        font: "#DDDDDD"
    },
    light: {
        bg: "#DDDDDD",
        border: "#1B998B",
        font: "#161A1D"
    }
}

export const fonts = {
    fixed: {
        1: "30px",
        2: "24px",
        3: "20px",
        4: "16px",
        5: "12px",
        6: "8px",
    },
    responsive: {
        1: "4vmin",
        2: "3vmin",
        3: "2.5vmin",
        4: "1.5vmin",
        5: "1vmin",
        6: "0.8vmin",
    }
}

export const IndexContainer = styled.div`
    background-color: ${({ theme }) => colors[theme].bg};
    transition: background-color .2s ease-in;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    width: 90vw;
    overflow: hidden;
    margin: auto;
    @media screen and (max-width:600px){
        width: 92vw
    }
    >div:last-child{
        margin: auto;
        width: 100%;
    }
    p{
        letter-spacing: 2px;
        line-height: 4vmin;
        @media screen and (max-width:600px){
            letter-spacing: 2px;
            line-height: 2rem;
            font-size: ${fonts.responsive[2]};
        }
    }
`
export const TitleContainer = styled.div`
    display: flex;
    position: relative;
    width: max-content;
    margin-top: 50px;
    p{
        font-size: ${fonts.responsive[1]};
        color: ${({ theme }) => colors[theme].font};
        transition: color .2s ease-in;
        margin: 0;
    }
    svg{
        margin-bottom: auto;
        margin-left: 20px;
        fill: ${({ theme }) => colors[theme].border};
        transition: fill .2s ease-in;
    }
    
    span{
        background: ${({ theme }) => colors[theme].border};
        margin-left: 20px;
        height: 3px;
        transition: background-color .2s ease-in;
    }
    @media screen and (max-width:400px){
        margin-left: 10vw;
        font-size: ${fonts.fixed[4]};
        span{
            height: 1px;
        }
    }
`

export const TitleText = styled.p`
    display: flex;
    font-size: ${fonts.responsive[1]};
`
export const TitleLines = styled.div`
    position: absolute;
    top: 0;
    left: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    span:nth-child(1){
        width: 5vw;
    }
    span:nth-child(2){
        width: 10vw;
    }
    span:nth-child(3){
        width: 20vw;
    }
    span:nth-child(4){
        width: 40vw;
    }
`

export const Title = ({ theme, title }) => (
    <TitleContainer theme={theme}>
        <TitleText>
            {title}
        </TitleText>
        <TitleLines>
            <span />
            <span />
            <span />
            <span />
        </TitleLines>
    </TitleContainer>
)


export const Diamond = () => (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4956 7.42551L7.2478 0.177734L2.79993e-05 7.42551L7.2478 14.6733L14.4956 7.42551Z" />
    </svg>
)

export const Square = () => (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.57432 24.8359C2.13542 24.8359 2.58917 25.2897 2.58915 25.8508C2.58912 26.4119 2.13534 26.8656 1.57424 26.8657C1.01313 26.8657 0.559384 26.4119 0.559411 25.8508C0.559437 25.2897 1.01322 24.836 1.57432 24.8359ZM0.559706 19.7812C0.559679 20.3423 1.01341 20.796 1.57452 20.796C2.13562 20.796 2.58941 20.3422 2.58943 19.7811C2.58946 19.22 2.13573 18.7662 1.57462 18.7663C1.01352 18.7663 0.559732 19.2201 0.559706 19.7812ZM0.559994 13.7115C0.559967 14.2726 1.0137 14.7263 1.57481 14.7263C2.13591 14.7263 2.5897 14.2725 2.58972 13.7114C2.58975 13.1503 2.13601 12.6966 1.57491 12.6966C1.01381 12.6966 0.560021 13.1504 0.559994 13.7115ZM0.560282 7.64181C0.560256 8.20291 1.01399 8.65665 1.57509 8.65662C2.1362 8.65659 2.58998 8.20281 2.59001 7.6417C2.59004 7.0806 2.1363 6.62686 1.5752 6.62689C1.01409 6.62692 0.560309 7.0807 0.560282 7.64181ZM0.560571 1.57212C0.560544 2.13323 1.01428 2.58696 1.57538 2.58693C2.13649 2.58691 2.59027 2.13312 2.5903 1.57202C2.59033 1.01091 2.13659 0.557178 1.57549 0.557205C1.01438 0.557232 0.560597 1.01102 0.560571 1.57212ZM6.62909 25.8506C6.62906 26.4117 7.08281 26.8654 7.64392 26.8654C8.20502 26.8654 8.65881 26.4116 8.65883 25.8505C8.65886 25.2894 8.20511 24.8356 7.64401 24.8356C7.0829 24.8357 6.62912 25.2895 6.62909 25.8506ZM6.62938 19.7809C6.62935 20.342 7.0831 20.7957 7.6442 20.7957C8.20531 20.7957 8.65909 20.3419 8.65912 19.7808C8.65915 19.2197 8.2054 18.7659 7.64429 18.766C7.08319 18.766 6.6294 19.2198 6.62938 19.7809ZM6.62968 13.7112C6.62965 14.2723 7.08339 14.726 7.64449 14.726C8.2056 14.726 8.65938 14.2722 8.65941 13.7111C8.65944 13.15 8.2057 12.6963 7.6446 12.6963C7.08349 12.6963 6.62971 13.1501 6.62968 13.7112ZM6.62997 7.64152C6.62994 8.20262 7.08368 8.65636 7.64478 8.65633C8.20588 8.6563 8.65967 8.20252 8.6597 7.64141C8.65972 7.08031 8.20599 6.62658 7.64488 6.6266C7.08378 6.62663 6.62999 7.08041 6.62997 7.64152ZM6.63026 1.57183C6.63023 2.13294 7.08396 2.58667 7.64507 2.58664C8.20617 2.58662 8.65996 2.13283 8.65999 1.57173C8.66001 1.01062 8.20628 0.556889 7.64517 0.556916C7.08407 0.556942 6.63028 1.01073 6.63026 1.57183ZM12.6988 25.8503C12.6987 26.4114 13.1525 26.8651 13.7136 26.8651C14.2747 26.8651 14.7285 26.4113 14.7285 25.8502C14.7285 25.2891 14.2748 24.8353 13.7137 24.8354C13.1526 24.8354 12.6988 25.2892 12.6988 25.8503ZM12.6991 19.7806C12.699 20.3417 13.1528 20.7954 13.7139 20.7954C14.275 20.7954 14.7288 20.3416 14.7288 19.7805C14.7288 19.2194 14.2751 18.7656 13.714 18.7657C13.1529 18.7657 12.6991 19.2195 12.6991 19.7806ZM12.6994 13.7109C12.6993 14.272 13.1531 14.7258 13.7142 14.7257C14.2753 14.7257 14.7291 14.2719 14.7291 13.7108C14.7291 13.1497 14.2754 12.696 13.7143 12.696C13.1532 12.696 12.6994 13.1498 12.6994 13.7109ZM12.6997 7.64123C12.6996 8.20233 13.1534 8.65607 13.7145 8.65604C14.2756 8.65602 14.7294 8.20223 14.7294 7.64113C14.7294 7.08002 14.2757 6.62629 13.7146 6.62631C13.1535 6.62634 12.6997 7.08013 12.6997 7.64123ZM12.6999 1.57154C12.6999 2.13265 13.1537 2.58638 13.7148 2.58636C14.2759 2.58633 14.7296 2.13254 14.7297 1.57144C14.7297 1.01034 14.276 0.556601 13.7149 0.556627C13.1538 0.556654 12.6975 1.01288 12.6999 1.57154ZM18.7685 25.85C18.7684 26.4111 19.2222 26.8648 19.7833 26.8648C20.3444 26.8648 20.7982 26.411 20.7982 25.8499C20.7982 25.2888 20.3445 24.835 19.7834 24.8351C19.2223 24.8351 18.7685 25.2889 18.7685 25.85ZM18.7687 19.7803C18.7687 20.3414 19.2225 20.7952 19.7836 20.7951C20.3447 20.7951 20.7985 20.3413 20.7985 19.7802C20.7985 19.2191 20.3448 18.7654 19.7837 18.7654C19.2226 18.7654 18.7688 19.2192 18.7687 19.7803ZM18.769 13.7106C18.769 14.2717 19.2228 14.7255 19.7839 14.7254C20.345 14.7254 20.7988 14.2716 20.7988 13.7105C20.7988 13.1494 20.3451 12.6957 19.784 12.6957C19.2229 12.6957 18.7691 13.1495 18.769 13.7106ZM18.7693 7.64093C18.7693 8.20203 19.223 8.65578 19.7842 8.65575C20.3453 8.65573 20.799 8.20194 20.7991 7.64084C20.7991 7.07973 20.3453 6.62598 19.7842 6.62601C19.2231 6.62604 18.7669 7.08226 18.7693 7.64093ZM18.7696 1.57125C18.7696 2.13236 19.2233 2.58609 19.7844 2.58607C20.3455 2.58604 20.7993 2.13226 20.7994 1.57115C20.7994 1.01005 20.3456 0.556312 19.7845 0.556339C19.2234 0.556366 18.7672 1.01259 18.7696 1.57125ZM24.8381 25.8497C24.8381 26.4108 25.2919 26.8646 25.853 26.8645C26.4141 26.8645 26.8679 26.4107 26.8679 25.8496C26.8679 25.2885 26.4142 24.8348 25.8531 24.8348C25.292 24.8348 24.8382 25.2886 24.8381 25.8497ZM24.8384 19.78C24.8384 20.3411 25.2922 20.7949 25.8533 20.7948C26.4144 20.7948 26.8682 20.341 26.8682 19.7799C26.8682 19.2188 26.4145 18.7651 25.8534 18.7651C25.2922 18.7651 24.8385 19.2189 24.8384 19.78ZM24.8387 13.7103C24.8387 14.2714 25.2924 14.7252 25.8536 14.7252C26.4147 14.7251 26.8684 14.2713 26.8685 13.7102C26.8685 13.1491 26.4147 12.6954 25.8536 12.6954C25.2925 12.6954 24.8363 13.1517 24.8387 13.7103ZM24.839 7.64064C24.839 8.20174 25.2927 8.65549 25.8538 8.65547C26.4149 8.65544 26.8687 8.20165 26.8688 7.64055C26.8688 7.07945 26.415 6.6257 25.8539 6.62572C25.2928 6.62575 24.8366 7.08197 24.839 7.64064ZM24.8369 1.57339C24.8368 2.1345 25.2906 2.58825 25.8517 2.58822C26.4128 2.58819 26.8666 2.13441 26.8666 1.57331C26.8666 1.0122 26.4129 0.558452 25.8518 0.558479C25.2931 0.556066 24.8369 1.01229 24.8369 1.57339Z" />
    </svg>
)

export const Line = () => (
    <svg height="2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M115.084 1L0.13446 0.999995" stroke="#FF9505" strokeWidth="2" stroke-miterlimit="10" />
    </svg>
)

export const Matrix = () => (
    <svg width="25" height="132" viewBox="0 0 25 132" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.8882 131.833H25L25 115.705H20.8882V131.833Z" fill="#FF9505" />
        <path d="M10.4441 131.833H14.5559L14.5559 115.705H10.4441L10.4441 131.833Z" fill="#FF9505" />
        <path d="M0 131.833H4.11182L4.11182 115.705H0L0 131.833Z" fill="#FF9505" />
        <path d="M20.8882 108.867H25L25 92.7389H20.8882V108.867Z" fill="#FF9505" />
        <path d="M10.4441 108.867H14.5559L14.5559 92.7389H10.4441L10.4441 108.867Z" fill="#FF9505" />
        <path d="M10.4441 85.9009H14.5559L14.5559 69.7727H10.4441L10.4441 85.9009Z" fill="#FF9505" />
        <path d="M0 85.9009H4.11182L4.11182 69.7727H0L0 85.9009Z" fill="#FF9505" />
        <path d="M20.8882 62.927H25L25 46.7988H20.8882V62.927Z" fill="#FF9505" />
        <path d="M0 62.927H4.11182L4.11182 46.7988H0L0 62.927Z" fill="#FF9505" />
        <path d="M20.8882 39.9609H25L25 23.8326H20.8882V39.9609Z" fill="#FF9505" />
        <path d="M10.4441 39.9609H14.5559L14.5559 23.8326H10.4441L10.4441 39.9609Z" fill="#FF9505" />
        <path d="M20.8882 16.9944H25L25 0.866211H20.8882V16.9944Z" fill="#FF9505" />
        <path d="M10.4441 16.9944H14.5559L14.5559 0.866211H10.4441L10.4441 16.9944Z" fill="#FF9505" />
        <path d="M0 16.9944H4.11182L4.11182 0.866211H0L0 16.9944Z" fill="#FF9505" />
    </svg>
)

// export const Telegram = () => (
//     <svg width="50" height="38" viewBox="0 0 50 38" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path fill-rule="evenodd" clip-rule="evenodd" d="M25 0.716553C11.1958 0.716553 0 8.98509 0 19.1869C0 29.3871 11.1958 37.6572 25 37.6572C38.8062 37.6572 50 29.3871 50 19.1869C50 8.98509 38.8062 0.716553 25 0.716553ZM31.7167 28.2235C32.1083 28.4282 32.6125 28.479 33.0625 28.3543C33.5104 28.2281 33.8417 27.9433 33.9417 27.5985C34.9979 23.9322 37.5604 14.6509 38.5208 11.317C38.5937 11.0645 38.4729 10.8029 38.2062 10.6351C37.9375 10.4673 37.5667 10.4196 37.2375 10.5089C32.1417 11.9034 16.4479 16.2532 10.0333 18.0063C9.62708 18.1187 9.3625 18.4065 9.375 18.7251C9.38958 19.0422 9.67917 19.3177 10.0958 19.41C12.9729 20.0457 16.7479 20.9308 16.7479 20.9308C16.7479 20.9308 18.5125 24.868 19.4312 26.869C19.5479 27.1214 19.8146 27.3184 20.1646 27.3861C20.5167 27.4539 20.8896 27.3831 21.1521 27.1999C22.6292 26.1702 24.9125 24.5771 24.9125 24.5771C24.9125 24.5771 29.2542 26.9275 31.7167 28.2235ZM18.3354 20.4321L20.3771 25.4052L20.8312 22.256C20.8312 22.256 28.7125 17.0027 33.2083 14.009C33.3396 13.9213 33.3562 13.7735 33.2479 13.6704C33.1396 13.5673 32.9396 13.5426 32.7917 13.6134C27.5833 16.07 18.3354 20.4321 18.3354 20.4321Z" fill="#FF9505"/>
//     </svg>
// )
export const Telegram = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c0-6.627-5.373-12-12-12zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
    </svg>
)


export const Github = () => (
    <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0.396c-8.839 0-16 7.167-16 16 0 7.073 4.584 13.068 10.937 15.183 0.803 0.151 1.093-0.344 1.093-0.772 0-0.38-0.009-1.385-0.015-2.719-4.453 0.964-5.391-2.151-5.391-2.151-0.729-1.844-1.781-2.339-1.781-2.339-1.448-0.989 0.115-0.968 0.115-0.968 1.604 0.109 2.448 1.645 2.448 1.645 1.427 2.448 3.744 1.74 4.661 1.328 0.14-1.031 0.557-1.74 1.011-2.135-3.552-0.401-7.287-1.776-7.287-7.907 0-1.751 0.62-3.177 1.645-4.297-0.177-0.401-0.719-2.031 0.141-4.235 0 0 1.339-0.427 4.4 1.641 1.281-0.355 2.641-0.532 4-0.541 1.36 0.009 2.719 0.187 4 0.541 3.043-2.068 4.381-1.641 4.381-1.641 0.859 2.204 0.317 3.833 0.161 4.235 1.015 1.12 1.635 2.547 1.635 4.297 0 6.145-3.74 7.5-7.296 7.891 0.556 0.479 1.077 1.464 1.077 2.959 0 2.14-0.020 3.864-0.020 4.385 0 0.416 0.28 0.916 1.104 0.755 6.4-2.093 10.979-8.093 10.979-15.156 0-8.833-7.161-16-16-16z" />
    </svg>
)

export const Stackoverflow = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg"><title>Stack Overflow icon</title><path d="M18.986 21.865v-6.404h2.134V24H1.844v-8.539h2.13v6.404h15.012zM6.111 19.731H16.85v-2.137H6.111v2.137zm.259-4.852l10.48 2.189.451-2.07-10.478-2.187-.453 2.068zm1.359-5.056l9.705 4.53.903-1.95-9.706-4.53-.902 1.936v.014zm2.715-4.785l8.217 6.855 1.359-1.62-8.216-6.853-1.35 1.617-.01.001zM15.751 0l-1.746 1.294 6.405 8.604 1.746-1.294L15.749 0h.002z" /></svg>
)

export const Upwork = () => (
    <svg  width="24px" height="24px" viewBox="0 0 1024 1024" role="img" xmlns="http://www.w3.org/2000/svg">
        <circle cx="512" cy="512" r="512"  />
        <path fill="black"  d="M362.26 544.5c-18.49 0-30.73-14-34.15-19.43 4.38-34.33 17.2-45.18 34.15-45.18C379 479.88 392 493 392 512.19s-13 32.31-29.74 32.31zm0-85.69c-30.15 0-47 19.25-51.87 39.06-5.48-10.1-9.54-23.6-12.69-36.16H256v50.79c0 18.42-8.57 32.05-25.32 32.05s-26.35-13.63-26.35-32.05l.19-50.79h-24v50.79c0 14.83 4.9 28.27 13.85 37.86 9.21 9.91 21.78 15.08 36.34 15.08 29 0 49.23-21.77 49.23-52.94v-34.13c3 11.23 10.24 32.81 24 51.74L291.06 602h24.42l8.5-50.92a66.79 66.79 0 0 0 8.89 6.12 55.15 55.15 0 0 0 27.19 8.2s1.48.06 2.26.06c29.9 0 53.67-22.65 53.67-53.26s-23.83-53.39-53.73-53.39zm345.29 13.75v-10.85H684v100.52h23.9v-39.38c0-24.23 2.26-41.64 35.44-39.37v-23c-15.49-1.1-27.54 2.05-35.79 12.08zm-166-10.85L524.26 532l-18.49-70.29h-30.42L456.8 532l-17.27-70.29H415.3l26.55 100.58h28.74l20-71.43 19.78 71.43h28.74l28.09-100.58zm78.22 82.85c-17 0-29.77-13.12-29.77-32.37s12.82-32.31 29.77-32.31c16.75 0 29.77 13.12 29.77 32.31s-12.98 32.37-29.73 32.37zm0-85.75c-30.09 0-53.67 22.84-53.67 53.38s23.58 53.19 53.67 53.19c29.9 0 53.67-22.65 53.67-53.19s-23.67-53.38-53.63-53.38zm157.78 54h5.54l33.38 49.47h27l-38.4-54.83c18.62-7.13 31.12-25.74 31.12-45.75h-23.81c0 21.71-17.46 29.91-34.79 29.91V422h-24v140.29h23.9z" />
    </svg >
)

export const Logo = () => (
    <svg width="54" height="54" viewBox="0 0 54 54" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="big" d="M27.2589 52.1616C41.066 52.1616 52.2589 40.9687 52.2589 27.1616C52.2589 13.3545 41.066 2.16162 27.2589 2.16162C13.4518 2.16162 2.25891 13.3545 2.25891 27.1616C2.25891 40.9687 13.4518 52.1616 27.2589 52.1616Z" fill="#161A1D" stroke="#DDDDDD" strokeWidth="3" />
        <path id="cletter" d="M36.7122 37.5393H23.7498C23.4181 37.5393 23.0588 37.5024 22.6719 37.4287C22.2941 37.3458 21.9164 37.2215 21.5386 37.0556C21.1702 36.8898 20.8154 36.6779 20.4746 36.42C20.1337 36.1528 19.8297 35.835 19.5625 35.4664C19.3046 35.0886 19.0972 34.6557 18.9406 34.1674C18.784 33.6699 18.7057 33.1125 18.7057 32.4953V22.7665C18.7057 22.4349 18.7426 22.0801 18.8163 21.7024C18.8992 21.3154 19.0236 20.9377 19.1894 20.5692C19.3552 20.1915 19.5718 19.8322 19.8389 19.4913C20.1061 19.1504 20.4239 18.851 20.7924 18.5931C21.1702 18.3259 21.6032 18.114 22.0915 17.9574C22.5797 17.8007 23.1325 17.7224 23.7498 17.7224H36.7122V21.3154H23.7498C23.2799 21.3154 22.9206 21.4399 22.6719 21.6885C22.4231 21.9373 22.2987 22.3058 22.2987 22.7941V32.4953C22.2987 32.9559 22.4231 33.3152 22.6719 33.5732C22.9298 33.8219 23.2891 33.9463 23.7498 33.9463H36.7122V37.5393Z" fill="#DDDDDD" />
        <path id="small" d="M22.542 38.0111C24.8866 38.0111 26.7873 36.1104 26.7873 33.7658C26.7873 31.4212 24.8866 29.5205 22.542 29.5205C20.1974 29.5205 18.2967 31.4212 18.2967 33.7658C18.2967 36.1104 20.1974 38.0111 22.542 38.0111Z" fill="#161A1D" stroke="#161A1D" />
    </svg>
)


export const GallerySvg = () => (
    <svg width="36px" height="36px" viewBox="0 0 36 36" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" >
        <path d="M32.12,10H3.88A1.88,1.88,0,0,0,2,11.88V30.12A1.88,1.88,0,0,0,3.88,32H32.12A1.88,1.88,0,0,0,34,30.12V11.88A1.88,1.88,0,0,0,32.12,10ZM32,30H4V12H32Z" className="clr-i-outline clr-i-outline-path-1"></path><path d="M8.56,19.45a3,3,0,1,0-3-3A3,3,0,0,0,8.56,19.45Zm0-4.6A1.6,1.6,0,1,1,7,16.45,1.6,1.6,0,0,1,8.56,14.85Z" className="clr-i-outline clr-i-outline-path-2"></path><path d="M7.9,28l6-6,3.18,3.18L14.26,28h2l7.46-7.46L30,26.77v-2L24.2,19a.71.71,0,0,0-1,0l-5.16,5.16L14.37,20.5a.71.71,0,0,0-1,0L5.92,28Z" className="clr-i-outline clr-i-outline-path-3"></path><path d="M30.14,3h0a1,1,0,0,0-1-1h-22a1,1,0,0,0-1,1h0V4h24Z" className="clr-i-outline clr-i-outline-path-4"></path><path d="M32.12,7V7a1,1,0,0,0-1-1h-26a1,1,0,0,0-1,1h0V8h28Z" className="clr-i-outline clr-i-outline-path-5"></path>
        <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
    </svg>
)


export const Link = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g data-name="Layer 2"><g data-name="external-link"><rect width="24" height="24" opacity="0" /><path d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1z" /><path d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1 1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z" /></g></g></svg>

)

export const Github2 = () => (
    <svg width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M13.18 11.309c-.718 0-1.3.807-1.3 1.799 0 .994.582 1.801 1.3 1.801s1.3-.807 1.3-1.801c-.001-.992-.582-1.799-1.3-1.799zm4.526-4.683c.149-.365.155-2.439-.635-4.426 0 0-1.811.199-4.551 2.08-.575-.16-1.548-.238-2.519-.238-.973 0-1.945.078-2.52.238C4.74 2.399 2.929 2.2 2.929 2.2c-.789 1.987-.781 4.061-.634 4.426C1.367 7.634.8 8.845.8 10.497c0 7.186 5.963 7.301 7.467 7.301l1.734.002 1.732-.002c1.506 0 7.467-.115 7.467-7.301 0-1.652-.566-2.863-1.494-3.871zm-7.678 10.289h-.056c-3.771 0-6.709-.449-6.709-4.115 0-.879.31-1.693 1.047-2.369C5.537 9.304 7.615 9.9 9.972 9.9h.056c2.357 0 4.436-.596 5.664.531.735.676 1.045 1.49 1.045 2.369 0 3.666-2.937 4.115-6.709 4.115zm-3.207-5.606c-.718 0-1.3.807-1.3 1.799 0 .994.582 1.801 1.3 1.801.719 0 1.301-.807 1.301-1.801 0-.992-.582-1.799-1.301-1.799z" /></svg>
)


export const Whatsapp = () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15.271 13.21c.578.185 1.078.416 1.543.7l-.031-.018c.529.235.986.51 1.403.833l-.015-.011c.02.061.032.13.032.203 0 .011 0 .021-.001.032v-.001c-.015.429-.11.832-.271 1.199l.008-.021c-.231.463-.616.82-1.087 1.01l-.014.005c-.459.243-1.001.393-1.576.411h-.006c-1.1-.146-2.094-.484-2.988-.982l.043.022c-1.022-.468-1.895-1.083-2.636-1.829l-.001-.001c-.824-.857-1.579-1.795-2.248-2.794l-.047-.074c-.636-.829-1.041-1.866-1.1-2.995l-.001-.013v-.124c.032-.975.468-1.843 1.144-2.447l.003-.003c.207-.206.491-.335.805-.341h.001c.101.003.198.011.292.025l-.013-.002c.087.013.188.021.292.023h.003c.019-.002.04-.003.062-.003.13 0 .251.039.352.105l-.002-.001c.107.118.189.261.238.418l.002.008q.124.31.512 1.364c.135.314.267.701.373 1.099l.014.063c-.076.361-.268.668-.533.889l-.003.002q-.535.566-.535.72c.004.088.034.168.081.234l-.001-.001c.405.829.936 1.533 1.576 2.119l.005.005c.675.609 1.446 1.132 2.282 1.54l.059.026c.097.063.213.103.339.109h.002q.233 0 .838-.752t.804-.752zm-3.147 8.216h.022c1.357 0 2.647-.285 3.814-.799l-.061.024c2.356-.994 4.193-2.831 5.163-5.124l.024-.063c.49-1.113.775-2.411.775-3.775s-.285-2.662-.799-3.837l.024.062c-.994-2.356-2.831-4.193-5.124-5.163l-.063-.024c-1.113-.49-2.411-.775-3.775-.775s-2.662.285-3.837.799l.062-.024c-2.356.994-4.193 2.831-5.163 5.124l-.024.063c-.49 1.117-.775 2.419-.775 3.787 0 2.141.698 4.12 1.879 5.72l-.019-.026-1.225 3.613 3.752-1.194c1.49 1.01 3.327 1.612 5.305 1.612h.047zm0-21.426h.033c1.628 0 3.176.342 4.575.959l-.073-.029c2.825 1.197 5.028 3.4 6.196 6.149l.029.076c.588 1.337.93 2.896.93 4.535s-.342 3.198-.959 4.609l.029-.074c-1.197 2.825-3.4 5.028-6.149 6.196l-.076.029c-1.327.588-2.875.93-4.503.93-.011 0-.023 0-.034 0h.002c-.016 0-.034 0-.053 0-2.059 0-3.992-.541-5.664-1.488l.057.03-6.465 2.078 2.109-6.279c-1.051-1.714-1.674-3.789-1.674-6.01 0-1.646.342-3.212.959-4.631l-.029.075c1.197-2.825 3.4-5.028 6.149-6.196l.076-.029c1.327-.588 2.875-.93 4.503-.93h.033-.002z" />
    </svg>
)

const bounce = keyframes`
    0%{
        transform: scale(2.5)
    }
    50%{
        transform: scale(.9)
    }
    100%{
        transform: scale(2.5)
    }
`

const SpinnerComponent = styled.div`
    display: flex;
    width: 5px;
    height: 5px;
    background: 2px solid;
    /* border-radius: 50%; */
    background-color: ${({ theme }) => colors[theme].border};
    animation: ${bounce} .6s linear infinite;
    transform-origin: center;
`

export const Spinner = ({ theme }) => (
    <SpinnerComponent theme={theme} />
)

const display = keyframes`
    0%{
        transform: translateX(-120vw);
        opacity: .2;

    }
    30%{
        transform: translateX(0vw);
        opacity: 1;
    }
    70%{
        transform: translateX(0vw);
        opacity: 1;
    }
    75%{
        opacity: .5;
    }
    100%{
        transform: translateX(120vw);
        opacity: 0;
    }
`

export const Notification = styled.p`
    position: fixed;
    bottom:100px;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: center;
    background:  ${({ theme }) => colors[theme].font};
    border-color:  ${({ theme }) => colors[theme].border};
    color: ${({ theme }) => colors[theme].bg};
    padding: 10px;
    animation: ${display} 6s ease-out infinite;
`